var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlowNoBorder = function SvgFlowNoBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.205h8V1.603h-8v1.602zM8 11.218h8V9.615H8v1.603zm-6.4 5.609h1.6v-1.603H1.6v1.603zm12.8-12.02H9.6v.802h3.2v2.404h4.8v4.808H6.4v-1.603H3.2v2.404h1.6v4.807H0v-4.807h1.6V9.615h4.8V8.013h4.8v-.801H8V4.808H3.2V0h11.2v4.808zM8 16.828h8v-1.603H8v1.603zM6.4 18.43v-4.807h11.2v4.807H6.4z"
  })));
};

export default SvgFlowNoBorder;